import { Box, Typography, List, ListItem } from '@mui/material'

export default function ProgramVisibilityList({ requirements }) {
  return (
    <Box p={3} border={1} borderColor="grey.300" borderRadius={2} mb={1}>
      <List>
        {requirements.map((req, i) => (
          <ListItem key={i}>
            {req.name} - {req.description}
          </ListItem>
        ))}
      </List>
    </Box>
  )
}
